import { ListItemIcon, ListItemText, MenuItem, styled } from '@mui/material';
import cn from 'classnames';
import type { MouseEventHandler } from 'react';
import Iconify from 'src/components/iconify';
import { AudioInputVolumeMeter } from '../AudioInputVolumeMeter/AudioInputVolumeMeter';

type MicDevice = {
  deviceId: string;
  id: string;
  label: string;
};

interface MicMenuItemProps {
  key: string;
  device: MicDevice;
  selected: boolean;
  icon: string;
  onClick: MouseEventHandler<HTMLElement>;
}

export const MicDeviceMenuItem = ({
  key,
  device,
  selected,
  onClick,
  icon,
}: MicMenuItemProps) => {
  return (
    <MenuItem key={key} onClick={onClick}>
      <StyledListItemIcon className={cn({ checkIcon: selected })}>
        <Iconify icon={icon} />
      </StyledListItemIcon>
      <StyledTextItem
        disableTypography
        secondaryTypographyProps={{
          noWrap: true,
          variant: 'caption',
        }}
        secondary={device.label}
      />
      <AudioInputVolumeMeter selected={selected} />
    </MenuItem>
  );
};

const StyledTextItem = styled(ListItemText)(({ theme }) => ({
  ...theme.typography.caption,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  paddingRight: theme.spacing(1),
}));

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  padding: theme.spacing(1),
  color: 'transparent',
  '&.checkIcon': {
    color: theme.palette.success.main,
  },
}));
